// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMStatusItem-module__font-s-10___Cge53 {
  font-size: 10px !important;
}

.CGMStatusItem-module__font-s-12___N6mys {
  font-size: 12px !important;
}

.CGMStatusItem-module__font-s-13___VZwCA {
  font-size: 13px !important;
}

.CGMStatusItem-module__font-s-14___IK8hs {
  font-size: 14px !important;
}

.CGMStatusItem-module__font-s-15___r0amm {
  font-size: 15px !important;
}

.CGMStatusItem-module__font-s-16___vrQpd {
  font-size: 16px !important;
}

.CGMStatusItem-module__font-s-18___X1rOB {
  font-size: 18px !important;
}

.CGMStatusItem-module__font-s-20___XShju {
  font-size: 20px !important;
}

.CGMStatusItem-module__font-s-22___g7dSN {
  font-size: 22px !important;
}

.CGMStatusItem-module__font-s-28___tTjbU {
  font-size: 28px !important;
}

.CGMStatusItem-module__font-w-400___pTglx {
  font-weight: 400 !important;
}

.CGMStatusItem-module__font-w-500___QtwgI {
  font-weight: 500 !important;
}

.CGMStatusItem-module__font-w-600___YUJIT {
  font-weight: 600 !important;
}

.CGMStatusItem-module__font-w-700___J_GTJ {
  font-weight: 700 !important;
}

.CGMStatusItem-module__p-5___BiB_f {
  padding: 5px !important;
}

.CGMStatusItem-module__p-12___xtPNU {
  padding: 12px !important;
}

.CGMStatusItem-module__p-16___cLlDz {
  padding: 16px !important;
}

.CGMStatusItem-module__p-30___gms8l {
  padding: 30px !important;
}

.CGMStatusItem-module__p-b-0___WOFPs {
  padding-bottom: 0 !important;
}

.CGMStatusItem-module__p-b-5___b8niZ {
  padding-bottom: 5px !important;
}

.CGMStatusItem-module__p-b-10___Dk_nu {
  padding-bottom: 10px !important;
}

.CGMStatusItem-module__p-b-12___USJqj {
  padding-bottom: 12px !important;
}

.CGMStatusItem-module__p-b-16___fdum9 {
  padding-bottom: 16px !important;
}

.CGMStatusItem-module__p-b-18___MnuA5 {
  padding-bottom: 18px !important;
}

.CGMStatusItem-module__p-b-20___XOA2y {
  padding-bottom: 20px !important;
}

.CGMStatusItem-module__p-b-25___mJzyu {
  padding-bottom: 25px !important;
}

.CGMStatusItem-module__p-b-30___LM2kj {
  padding-bottom: 30px !important;
}

.CGMStatusItem-module__p-b-50___hn8BB {
  padding-bottom: 50px !important;
}

.CGMStatusItem-module__p-t-0___DlGdB {
  padding-top: 0 !important;
}

.CGMStatusItem-module__p-t-12___nvf2A {
  padding-top: 12px !important;
}

.CGMStatusItem-module__p-t-16___z4ydL {
  padding-top: 16px !important;
}

.CGMStatusItem-module__p-t-18___i9BNi {
  padding-top: 18px !important;
}

.CGMStatusItem-module__p-t-20___Wx74_ {
  padding-top: 20px !important;
}

.CGMStatusItem-module__p-t-30___bxyzo {
  padding-top: 30px !important;
}

.CGMStatusItem-module__p-t-40___ZsqWt {
  padding-top: 40px !important;
}

.CGMStatusItem-module__p-t-50___ESDVQ {
  padding-top: 50px !important;
}

.CGMStatusItem-module__p-l-20___oTjk2 {
  padding-left: 20px !important;
}

.CGMStatusItem-module__p-l-30___cVfW2 {
  padding-left: 30px !important;
}

.CGMStatusItem-module__p-l-40___MxSZN {
  padding-left: 40px !important;
}

.CGMStatusItem-module__p-r-16___ndEpg {
  padding-right: 16px !important;
}

.CGMStatusItem-module__p-r-20___q73be {
  padding-right: 20px !important;
}

.CGMStatusItem-module__p-r-30___yDFah {
  padding-right: 30px !important;
}

.CGMStatusItem-module__p-r-50___rQqP5 {
  padding-right: 50px !important;
}

.CGMStatusItem-module__p-r-60___o5Ul5 {
  padding-right: 60px !important;
}

.CGMStatusItem-module__m-b-1___kSPk6 {
  margin-bottom: 1px !important;
}

.CGMStatusItem-module__m-b-2___zAceb {
  margin-bottom: 2px !important;
}

.CGMStatusItem-module__m-b-6___BYdxp {
  margin-bottom: 6px !important;
}

.CGMStatusItem-module__m-b-8___ceqYR {
  margin-bottom: 8px !important;
}

.CGMStatusItem-module__m-b-10___LLxYS {
  margin-bottom: 10px !important;
}

.CGMStatusItem-module__m-b-14___sfWuK {
  margin-bottom: 14px !important;
}

.CGMStatusItem-module__m-b-16___YMa8h {
  margin-bottom: 16px !important;
}

.CGMStatusItem-module__m-b-20___T897B {
  margin-bottom: 20px !important;
}

.CGMStatusItem-module__m-b-22___fNyx1 {
  margin-bottom: 22px !important;
}

.CGMStatusItem-module__m-b-24___h6Y2d {
  margin-bottom: 24px !important;
}

.CGMStatusItem-module__m-b-30___E8kEZ {
  margin-bottom: 30px !important;
}

.CGMStatusItem-module__m-b-32___LrxLL {
  margin-bottom: 32px !important;
}

.CGMStatusItem-module__m-b-40___XKAr8 {
  margin-bottom: 40px !important;
}

.CGMStatusItem-module__m-t-2___bbuBS {
  margin-top: 2px !important;
}

.CGMStatusItem-module__m-t-3___v2q5y {
  margin-top: 3px !important;
}

.CGMStatusItem-module__m-t-4___XiUxm {
  margin-top: 4px !important;
}

.CGMStatusItem-module__m-t-5___kOgJ4 {
  margin-top: 5px !important;
}

.CGMStatusItem-module__m-t-8___uXDNM {
  margin-top: 8px !important;
}

.CGMStatusItem-module__m-t-10___zuDTU {
  margin-top: 10px !important;
}

.CGMStatusItem-module__m-t-15___rtwiO {
  margin-top: 15px !important;
}

.CGMStatusItem-module__m-t-16___t0a9Y {
  margin-top: 16px !important;
}

.CGMStatusItem-module__m-t-20___GpZQV {
  margin-top: 20px !important;
}

.CGMStatusItem-module__m-t-22___S4PoH {
  margin-top: 22px !important;
}

.CGMStatusItem-module__m-t-30___Z85Ij {
  margin-top: 30px !important;
}

.CGMStatusItem-module__m-t-32___CMKZT {
  margin-top: 32px !important;
}

.CGMStatusItem-module__m-l-auto___gireE {
  margin-left: auto !important;
}

.CGMStatusItem-module__m-l-4___mr0lL {
  margin-left: 4px !important;
}

.CGMStatusItem-module__m-l-5___oDjnu {
  margin-left: 5px !important;
}

.CGMStatusItem-module__m-l-6____QlRj {
  margin-left: 6px !important;
}

.CGMStatusItem-module__m-l-8___mtsMh {
  margin-left: 8px !important;
}

.CGMStatusItem-module__m-l-10___SY5Pv {
  margin-left: 10px !important;
}

.CGMStatusItem-module__m-l-16___J5u3P {
  margin-left: 16px !important;
}

.CGMStatusItem-module__m-l-20___h_oTr {
  margin-left: 20px !important;
}

.CGMStatusItem-module__m-l-24___yEoyY {
  margin-left: 24px !important;
}

.CGMStatusItem-module__m-l-30___QMOMH {
  margin-left: 30px !important;
}

.CGMStatusItem-module__m-l-35___pEfxb {
  margin-left: 35px !important;
}

.CGMStatusItem-module__m-l-40___Njecv {
  margin-left: 40px !important;
}

.CGMStatusItem-module__m-r-8___CHsx_ {
  margin-right: 8px !important;
}

.CGMStatusItem-module__m-r-10___X5HMT {
  margin-right: 10px !important;
}

.CGMStatusItem-module__m-r-16___WfDTH {
  margin-right: 16px !important;
}

.CGMStatusItem-module__m-r-20____XHlE {
  margin-right: 20px !important;
}

.CGMStatusItem-module__m-r-24___mC_MZ {
  margin-right: 24px !important;
}

.CGMStatusItem-module__m-r-30___vmOWt {
  margin-right: 30px !important;
}

.CGMStatusItem-module__m-r-40___hGyyT {
  margin-right: 40px !important;
}

.CGMStatusItem-module__border-r-3___qECM9 {
  border-radius: 3px !important;
}

.CGMStatusItem-module__border-r-4___CihyT {
  border-radius: 4px !important;
}

.CGMStatusItem-module__border-r-6___sjOOi {
  border-radius: 6px !important;
}

.CGMStatusItem-module__border-r-10___DiQXH {
  border-radius: 10px !important;
}

.CGMStatusItem-module__border-r-12___Mr_0y {
  border-radius: 12px !important;
}

.CGMStatusItem-module__border-r-16___Ow9ii {
  border-radius: 16px !important;
}

.CGMStatusItem-module__border-r-50___cxCwA {
  border-radius: 50% !important;
}

.CGMStatusItem-module__primary-border___R4k_w {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMStatusItem-module__primary-border-b___Ppz4F {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMStatusItem-module__primary-border-t___DAJr7 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMStatusItem-module__primary-border-l___QfkdJ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMStatusItem-module__primary-border-r___BaKZT {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMStatusItem-module__secondary-border___gmbIH {
  border: 1px solid #637768;
}

.CGMStatusItem-module__secondary-border-b___gYSnw {
  border-bottom: 1px solid #637768;
}

.CGMStatusItem-module__secondary-border-t___HJTe6 {
  border-top: 1px solid #637768;
}

.CGMStatusItem-module__secondary-border-l___LRqGt {
  border-left: 1px solid #637768;
}

.CGMStatusItem-module__secondary-border-r___noUsN {
  border-right: 1px solid #637768;
}

.CGMStatusItem-module__gap-0___G7vux {
  gap: 0 !important;
}

.CGMStatusItem-module__gap-2___lOjzF {
  gap: 2px !important;
}

.CGMStatusItem-module__gap-4___FchiT {
  gap: 4px !important;
}

.CGMStatusItem-module__gap-5___JMu66 {
  gap: 5px !important;
}

.CGMStatusItem-module__gap-6___Qe50k {
  gap: 6px !important;
}

.CGMStatusItem-module__gap-8___MFRPe {
  gap: 8px !important;
}

.CGMStatusItem-module__gap-10___OHFcK {
  gap: 10px !important;
}

.CGMStatusItem-module__gap-12___r91Vt {
  gap: 12px !important;
}

.CGMStatusItem-module__gap-14___x_4t2 {
  gap: 14px !important;
}

.CGMStatusItem-module__gap-16___ngili {
  gap: 16px !important;
}

.CGMStatusItem-module__gap-18___Vstqy {
  gap: 18px !important;
}

.CGMStatusItem-module__gap-20___gHRJI {
  gap: 20px !important;
}

.CGMStatusItem-module__gap-24____ZzCm {
  gap: 24px !important;
}

.CGMStatusItem-module__gap-26___Ha_vH {
  gap: 26px !important;
}

.CGMStatusItem-module__gap-30___HuoBP {
  gap: 30px !important;
}

.CGMStatusItem-module__gap-32___dVsAn {
  gap: 32px !important;
}

.CGMStatusItem-module__gap-40___NFY0t {
  gap: 40px !important;
}

.CGMStatusItem-module__gap-50___c5Atx {
  gap: 50px !important;
}

.CGMStatusItem-module__flex-1___kusQs {
  flex: 1;
}

.CGMStatusItem-module__flex-none___eFvv_ {
  flex: none !important;
}

.CGMStatusItem-module__flex-column___D_G7n {
  display: flex;
  flex-direction: column !important;
}

.CGMStatusItem-module__flex-row___lKaKP {
  display: flex;
  flex-direction: row !important;
}

.CGMStatusItem-module__vertically-centered___jYzBD {
  display: flex;
  align-items: center !important;
}

.CGMStatusItem-module__horizontally-centered___aLe5m {
  display: flex;
  justify-content: center !important;
}

.CGMStatusItem-module__horizontally-end___l2mT4 {
  display: flex;
  justify-content: end !important;
}

.CGMStatusItem-module__vertically-start___Ign_Y {
  display: flex;
  align-items: start !important;
}

.CGMStatusItem-module__space-between___RyaAs {
  display: flex;
  justify-content: space-between !important;
}

.CGMStatusItem-module__flex-wrap___YwxMU {
  flex-wrap: wrap !important;
}

.CGMStatusItem-module__height-100___tCgz1 {
  height: 100%;
}

.CGMStatusItem-module__width-50___AY7MW {
  width: 50% !important;
}

.CGMStatusItem-module__width-100___qcW2o {
  width: 100%;
}

.CGMStatusItem-module__cursor-pointer___V_jQN {
  cursor: pointer;
}

.CGMStatusItem-module__cursor-not-allowed___gVRUJ {
  cursor: not-allowed !important;
}

.CGMStatusItem-module__absolute-centered___OJ15e {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMStatusItem-module__absolute___m4xHt {
  position: absolute;
}

.CGMStatusItem-module__relative___tHSiN {
  position: relative;
}

.CGMStatusItem-module__fixed___A5gop {
  position: fixed;
}

.CGMStatusItem-module__visible___iMNms {
  opacity: 1;
}

.CGMStatusItem-module__invisible___kzKoz {
  opacity: 0;
}

.CGMStatusItem-module__col-90___KQjkB {
  width: 90% !important;
}

.CGMStatusItem-module__col-auto___zZxW4 {
  width: auto !important;
}

.CGMStatusItem-module__medical-tabs___F3XMN {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMStatusItem-module__medical-table-new___Th1VE {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMStatusItem-module__medical-table-new___Th1VE:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMStatusItem-module__medical-table-new___Th1VE::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMStatusItem-module__medical-table-new___Th1VE::-webkit-scrollbar-track {
  display: none;
}
.CGMStatusItem-module__medical-table-new___Th1VE.CGMStatusItem-module__no-pagination___nRrZu {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMStatusItem-module__medical-table-new___Th1VE.CGMStatusItem-module__no-pagination___nRrZu:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMStatusItem-module__medical-table-new___Th1VE.CGMStatusItem-module__no-pagination___nRrZu::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMStatusItem-module__medical-table-new___Th1VE.CGMStatusItem-module__no-pagination___nRrZu::-webkit-scrollbar-track {
  display: none;
}

.CGMStatusItem-module__medical-table-empty___ls2u8 {
  padding: 14px 40px !important;
}

.CGMStatusItem-module__icon-btn___rBS27 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMStatusItem-module__search-icon___ByZtf {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMStatusItem-module__disable-select___j5GHS {
  user-select: none;
}

.CGMStatusItem-module__break-word___lJuCh {
  word-break: break-word;
}

.CGMStatusItem-module__popup-clear-btn___Ib77E {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMStatusItem-module__scroll-m-b-20___XIsj5 {
  scroll-margin-bottom: 20px;
}

.CGMStatusItem-module__title___T_NAE {
  color: #859989;
}

.CGMStatusItem-module__status___foBDM {
  color: #375844;
}

.CGMStatusItem-module__description___ugRIa {
  color: #c56836;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/items/CGMStatusItem/CGMStatusItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.title {\n  color: get-color(greenNew, medium);\n}\n\n.status {\n  color: get-color(greenNew, dark);\n}\n\n.description {\n  color: get-color(orangeNew, dark);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMStatusItem-module__font-s-10___Cge53`,
	"fontS12": `CGMStatusItem-module__font-s-12___N6mys`,
	"fontS13": `CGMStatusItem-module__font-s-13___VZwCA`,
	"fontS14": `CGMStatusItem-module__font-s-14___IK8hs`,
	"fontS15": `CGMStatusItem-module__font-s-15___r0amm`,
	"fontS16": `CGMStatusItem-module__font-s-16___vrQpd`,
	"fontS18": `CGMStatusItem-module__font-s-18___X1rOB`,
	"fontS20": `CGMStatusItem-module__font-s-20___XShju`,
	"fontS22": `CGMStatusItem-module__font-s-22___g7dSN`,
	"fontS28": `CGMStatusItem-module__font-s-28___tTjbU`,
	"fontW400": `CGMStatusItem-module__font-w-400___pTglx`,
	"fontW500": `CGMStatusItem-module__font-w-500___QtwgI`,
	"fontW600": `CGMStatusItem-module__font-w-600___YUJIT`,
	"fontW700": `CGMStatusItem-module__font-w-700___J_GTJ`,
	"p5": `CGMStatusItem-module__p-5___BiB_f`,
	"p12": `CGMStatusItem-module__p-12___xtPNU`,
	"p16": `CGMStatusItem-module__p-16___cLlDz`,
	"p30": `CGMStatusItem-module__p-30___gms8l`,
	"pB0": `CGMStatusItem-module__p-b-0___WOFPs`,
	"pB5": `CGMStatusItem-module__p-b-5___b8niZ`,
	"pB10": `CGMStatusItem-module__p-b-10___Dk_nu`,
	"pB12": `CGMStatusItem-module__p-b-12___USJqj`,
	"pB16": `CGMStatusItem-module__p-b-16___fdum9`,
	"pB18": `CGMStatusItem-module__p-b-18___MnuA5`,
	"pB20": `CGMStatusItem-module__p-b-20___XOA2y`,
	"pB25": `CGMStatusItem-module__p-b-25___mJzyu`,
	"pB30": `CGMStatusItem-module__p-b-30___LM2kj`,
	"pB50": `CGMStatusItem-module__p-b-50___hn8BB`,
	"pT0": `CGMStatusItem-module__p-t-0___DlGdB`,
	"pT12": `CGMStatusItem-module__p-t-12___nvf2A`,
	"pT16": `CGMStatusItem-module__p-t-16___z4ydL`,
	"pT18": `CGMStatusItem-module__p-t-18___i9BNi`,
	"pT20": `CGMStatusItem-module__p-t-20___Wx74_`,
	"pT30": `CGMStatusItem-module__p-t-30___bxyzo`,
	"pT40": `CGMStatusItem-module__p-t-40___ZsqWt`,
	"pT50": `CGMStatusItem-module__p-t-50___ESDVQ`,
	"pL20": `CGMStatusItem-module__p-l-20___oTjk2`,
	"pL30": `CGMStatusItem-module__p-l-30___cVfW2`,
	"pL40": `CGMStatusItem-module__p-l-40___MxSZN`,
	"pR16": `CGMStatusItem-module__p-r-16___ndEpg`,
	"pR20": `CGMStatusItem-module__p-r-20___q73be`,
	"pR30": `CGMStatusItem-module__p-r-30___yDFah`,
	"pR50": `CGMStatusItem-module__p-r-50___rQqP5`,
	"pR60": `CGMStatusItem-module__p-r-60___o5Ul5`,
	"mB1": `CGMStatusItem-module__m-b-1___kSPk6`,
	"mB2": `CGMStatusItem-module__m-b-2___zAceb`,
	"mB6": `CGMStatusItem-module__m-b-6___BYdxp`,
	"mB8": `CGMStatusItem-module__m-b-8___ceqYR`,
	"mB10": `CGMStatusItem-module__m-b-10___LLxYS`,
	"mB14": `CGMStatusItem-module__m-b-14___sfWuK`,
	"mB16": `CGMStatusItem-module__m-b-16___YMa8h`,
	"mB20": `CGMStatusItem-module__m-b-20___T897B`,
	"mB22": `CGMStatusItem-module__m-b-22___fNyx1`,
	"mB24": `CGMStatusItem-module__m-b-24___h6Y2d`,
	"mB30": `CGMStatusItem-module__m-b-30___E8kEZ`,
	"mB32": `CGMStatusItem-module__m-b-32___LrxLL`,
	"mB40": `CGMStatusItem-module__m-b-40___XKAr8`,
	"mT2": `CGMStatusItem-module__m-t-2___bbuBS`,
	"mT3": `CGMStatusItem-module__m-t-3___v2q5y`,
	"mT4": `CGMStatusItem-module__m-t-4___XiUxm`,
	"mT5": `CGMStatusItem-module__m-t-5___kOgJ4`,
	"mT8": `CGMStatusItem-module__m-t-8___uXDNM`,
	"mT10": `CGMStatusItem-module__m-t-10___zuDTU`,
	"mT15": `CGMStatusItem-module__m-t-15___rtwiO`,
	"mT16": `CGMStatusItem-module__m-t-16___t0a9Y`,
	"mT20": `CGMStatusItem-module__m-t-20___GpZQV`,
	"mT22": `CGMStatusItem-module__m-t-22___S4PoH`,
	"mT30": `CGMStatusItem-module__m-t-30___Z85Ij`,
	"mT32": `CGMStatusItem-module__m-t-32___CMKZT`,
	"mLAuto": `CGMStatusItem-module__m-l-auto___gireE`,
	"mL4": `CGMStatusItem-module__m-l-4___mr0lL`,
	"mL5": `CGMStatusItem-module__m-l-5___oDjnu`,
	"mL6": `CGMStatusItem-module__m-l-6____QlRj`,
	"mL8": `CGMStatusItem-module__m-l-8___mtsMh`,
	"mL10": `CGMStatusItem-module__m-l-10___SY5Pv`,
	"mL16": `CGMStatusItem-module__m-l-16___J5u3P`,
	"mL20": `CGMStatusItem-module__m-l-20___h_oTr`,
	"mL24": `CGMStatusItem-module__m-l-24___yEoyY`,
	"mL30": `CGMStatusItem-module__m-l-30___QMOMH`,
	"mL35": `CGMStatusItem-module__m-l-35___pEfxb`,
	"mL40": `CGMStatusItem-module__m-l-40___Njecv`,
	"mR8": `CGMStatusItem-module__m-r-8___CHsx_`,
	"mR10": `CGMStatusItem-module__m-r-10___X5HMT`,
	"mR16": `CGMStatusItem-module__m-r-16___WfDTH`,
	"mR20": `CGMStatusItem-module__m-r-20____XHlE`,
	"mR24": `CGMStatusItem-module__m-r-24___mC_MZ`,
	"mR30": `CGMStatusItem-module__m-r-30___vmOWt`,
	"mR40": `CGMStatusItem-module__m-r-40___hGyyT`,
	"borderR3": `CGMStatusItem-module__border-r-3___qECM9`,
	"borderR4": `CGMStatusItem-module__border-r-4___CihyT`,
	"borderR6": `CGMStatusItem-module__border-r-6___sjOOi`,
	"borderR10": `CGMStatusItem-module__border-r-10___DiQXH`,
	"borderR12": `CGMStatusItem-module__border-r-12___Mr_0y`,
	"borderR16": `CGMStatusItem-module__border-r-16___Ow9ii`,
	"borderR50": `CGMStatusItem-module__border-r-50___cxCwA`,
	"primaryBorder": `CGMStatusItem-module__primary-border___R4k_w`,
	"primaryBorderB": `CGMStatusItem-module__primary-border-b___Ppz4F`,
	"primaryBorderT": `CGMStatusItem-module__primary-border-t___DAJr7`,
	"primaryBorderL": `CGMStatusItem-module__primary-border-l___QfkdJ`,
	"primaryBorderR": `CGMStatusItem-module__primary-border-r___BaKZT`,
	"secondaryBorder": `CGMStatusItem-module__secondary-border___gmbIH`,
	"secondaryBorderB": `CGMStatusItem-module__secondary-border-b___gYSnw`,
	"secondaryBorderT": `CGMStatusItem-module__secondary-border-t___HJTe6`,
	"secondaryBorderL": `CGMStatusItem-module__secondary-border-l___LRqGt`,
	"secondaryBorderR": `CGMStatusItem-module__secondary-border-r___noUsN`,
	"gap0": `CGMStatusItem-module__gap-0___G7vux`,
	"gap2": `CGMStatusItem-module__gap-2___lOjzF`,
	"gap4": `CGMStatusItem-module__gap-4___FchiT`,
	"gap5": `CGMStatusItem-module__gap-5___JMu66`,
	"gap6": `CGMStatusItem-module__gap-6___Qe50k`,
	"gap8": `CGMStatusItem-module__gap-8___MFRPe`,
	"gap10": `CGMStatusItem-module__gap-10___OHFcK`,
	"gap12": `CGMStatusItem-module__gap-12___r91Vt`,
	"gap14": `CGMStatusItem-module__gap-14___x_4t2`,
	"gap16": `CGMStatusItem-module__gap-16___ngili`,
	"gap18": `CGMStatusItem-module__gap-18___Vstqy`,
	"gap20": `CGMStatusItem-module__gap-20___gHRJI`,
	"gap24": `CGMStatusItem-module__gap-24____ZzCm`,
	"gap26": `CGMStatusItem-module__gap-26___Ha_vH`,
	"gap30": `CGMStatusItem-module__gap-30___HuoBP`,
	"gap32": `CGMStatusItem-module__gap-32___dVsAn`,
	"gap40": `CGMStatusItem-module__gap-40___NFY0t`,
	"gap50": `CGMStatusItem-module__gap-50___c5Atx`,
	"flex1": `CGMStatusItem-module__flex-1___kusQs`,
	"flexNone": `CGMStatusItem-module__flex-none___eFvv_`,
	"flexColumn": `CGMStatusItem-module__flex-column___D_G7n`,
	"flexRow": `CGMStatusItem-module__flex-row___lKaKP`,
	"verticallyCentered": `CGMStatusItem-module__vertically-centered___jYzBD`,
	"horizontallyCentered": `CGMStatusItem-module__horizontally-centered___aLe5m`,
	"horizontallyEnd": `CGMStatusItem-module__horizontally-end___l2mT4`,
	"verticallyStart": `CGMStatusItem-module__vertically-start___Ign_Y`,
	"spaceBetween": `CGMStatusItem-module__space-between___RyaAs`,
	"flexWrap": `CGMStatusItem-module__flex-wrap___YwxMU`,
	"height100": `CGMStatusItem-module__height-100___tCgz1`,
	"width50": `CGMStatusItem-module__width-50___AY7MW`,
	"width100": `CGMStatusItem-module__width-100___qcW2o`,
	"cursorPointer": `CGMStatusItem-module__cursor-pointer___V_jQN`,
	"cursorNotAllowed": `CGMStatusItem-module__cursor-not-allowed___gVRUJ`,
	"absoluteCentered": `CGMStatusItem-module__absolute-centered___OJ15e`,
	"absolute": `CGMStatusItem-module__absolute___m4xHt`,
	"relative": `CGMStatusItem-module__relative___tHSiN`,
	"fixed": `CGMStatusItem-module__fixed___A5gop`,
	"visible": `CGMStatusItem-module__visible___iMNms`,
	"invisible": `CGMStatusItem-module__invisible___kzKoz`,
	"col90": `CGMStatusItem-module__col-90___KQjkB`,
	"colAuto": `CGMStatusItem-module__col-auto___zZxW4`,
	"medicalTabs": `CGMStatusItem-module__medical-tabs___F3XMN`,
	"medicalTableNew": `CGMStatusItem-module__medical-table-new___Th1VE`,
	"noPagination": `CGMStatusItem-module__no-pagination___nRrZu`,
	"medicalTableEmpty": `CGMStatusItem-module__medical-table-empty___ls2u8`,
	"iconBtn": `CGMStatusItem-module__icon-btn___rBS27`,
	"searchIcon": `CGMStatusItem-module__search-icon___ByZtf`,
	"disableSelect": `CGMStatusItem-module__disable-select___j5GHS`,
	"breakWord": `CGMStatusItem-module__break-word___lJuCh`,
	"popupClearBtn": `CGMStatusItem-module__popup-clear-btn___Ib77E`,
	"scrollMB20": `CGMStatusItem-module__scroll-m-b-20___XIsj5`,
	"title": `CGMStatusItem-module__title___T_NAE`,
	"status": `CGMStatusItem-module__status___foBDM`,
	"description": `CGMStatusItem-module__description___ugRIa`
};
module.exports = ___CSS_LOADER_EXPORT___;
